import { IconProps } from "@iconify/react";

export const PAGES: Array<{
  icon: IconProps["icon"];
  iconProps?: IconProps;
  link: string;
  title: string;
  scope?: string;
  newTab?: boolean;
}> = [
  {
    icon: "ic:twotone-construction",
    title: "Product Builder",
    link: "/productBuilder",
    scope: "product:view feature:product_builder",
  },
  {
    icon: "whh:fence",
    title: "Product Configurations",
    link: "/productConfigs",
    scope: "product_configuration:view feature:product_configuration",
  },
  {
    icon: "ant-design:calendar-twotone",
    title: "Bid Calendar",
    link: "/project/calendar",
    scope: "bid_calendar:view",
  },
  {
    icon: "codicon:project",
    title: "Project Search",
    link: "/project/search",
    scope: "project:view",
  },
  {
    icon: "fa:building",
    title: "Customers",
    link: "/company",
    scope: "company:view feature:company",
  },
  {
    icon: "carbon:inventory-management",
    title: "Stock Items",
    link: "/inventory",
    scope: "inventory:view feature:inventory",
  },
  {
    icon: "et:documents",
    title: "Global Documents",
    link: "/files",
  },
  {
    icon: "mdi:cog",
    title: "Admin",
    link: "/admin",
    scope: "organization:admin",
  },
  {
    icon: "akar-icons:youtube-fill",
    title: "How to videos",
    link: "https://www.youtube.com/playlist?list=PLw7wUap4NdFvl2PI9zCxLu0dLGr6XSG6M",
    newTab: true,
  },
  {
    icon: "bi:bug-fill",
    title: "Report a bug",
    link: "https://forms.monday.com/forms/6fea69bff8f99cfad902825ba4cba077?r=use1",
    newTab: true,
  },
  {
    icon: "healthicons:contact-support-outline",
    title: "Request Help",
    link: "https://forms.monday.com/forms/c0d7ae7dad377d1b7745f5fa05ea9204?r=use1",
    newTab: true,
  },
  {
    icon: "material-symbols:video-camera-front-outline",
    title: "Request a video",
    link: "https://forms.monday.com/forms/47c95fb70a82c9f4ce5eab55a7050243?r=use1",
    newTab: true,
  },
];
